import { inject, Injectable } from '@angular/core';
import { SubscriptionFeatureService } from '@rma/billing/subscription-plans/public/api-subscription-features';
import { SubscriptionAccess } from '@rma/generic/domain/to-be-sorted';
import { FeatureFlags, FeatureFlagService, TempFeatureFlags } from '@rma/generic/util/feature-flags';
import { ConnectToGmbService } from '@rma/linked-accounts/public/api-connect-gmb';
import { combineLatest, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SideNavigationConfigService {
  private readonly subscriptionFeatureService = inject(SubscriptionFeatureService);
  private readonly featuresService = inject(FeatureFlagService);
  private readonly connectToGmbService = inject(ConnectToGmbService);

  public readonly showSocialStudioLink$ = this.featuresService.showSocialStudioLink$;

  public getGoogleConfig() {
    return combineLatest({
      hasConnectedGmb: this.connectToGmbService.getConnectToGmbSettings().pipe(map((x) => (x?.hasSignedIn && x?.enabled) || false)),
      hasGoogleConnect: this.getSubscriptionAccess('HasGoogleConnect'),
      hasOwnGoogleAskForReviews: this.getSubscriptionAccess('HasOwnGoogleAskForReviews'),
      hasGoogleAskForReviews: this.getSubscriptionAccess('HasGoogleAskForReviews'),
    });
  }

  public getMarketReportConfig() {
    return combineLatest({
      hideMarketReport: this.featuresService.getFeature$(FeatureFlags.HideMarketReports, false),
      hasMarketReportAccess: this.getSubscriptionAccess('HasListingReport'),
    });
  }

  public getSubscriptionAccess(access: SubscriptionAccess) {
    return this.subscriptionFeatureService.hasAccess(access);
  }

  public getFeature<T = boolean>(feature: FeatureFlags | TempFeatureFlags, defaultValue: T): Observable<T> {
    return this.featuresService.getFeature$<T>(feature, defaultValue);
  }

  public getLiveFeature<T = boolean>(feature: FeatureFlags | TempFeatureFlags, defaultValue: T): Observable<T> {
    return this.featuresService.getLiveFeature$<T>(feature, defaultValue);
  }
}
